import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "gfu-project-summary-action gfu-media _ai-c",
  "data-qa": "project-summary-backer"
}
const _hoisted_2 = { class: "gfu-media__body" }
const _hoisted_3 = { class: "gfu-hd gfu-hd--h4 _ma-0" }
const _hoisted_4 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_icon, {
      name: "brand-backer",
      class: "gfu-project-summary-action__side _tc--accent",
      "icon-namespace": "ga"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString($options.backerNumberText), 1 /* TEXT */),
      ($options.hasHref)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: $props.href,
            class: "gfu-link gfu-link--accent"
          }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryBoxAddMoreItemsText), 9 /* TEXT, PROPS */, _hoisted_4))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}